import DatePicker from 'components/DatePickerStyles/DatePicker/index'
import Input from 'components/Form/Input'
import RadioButton from 'components/Form/Radio'
import RichEditor from 'components/RichEditor/RoundRichText.js'
import Select, { FormItem } from 'components/Select'
import { RadioGroup } from 'components/UIComponents/FormStyles'
import Toggle from 'components/UIComponents/Toggle/ToggleIndex.js'
import FileReader from 'components/Uploader/FileReader'
import Clock from 'components/icons/Clock'
import moment from 'moment'
import dayjs from 'dayjs'
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react'
import {
  dateConversion,
  isReturnBoolean,
  timeCheck,
} from '../../../../../../utils/rolecreationHelpers'

import { Col, Row, Spin } from 'antd'
import { TimeStyles } from 'components/DatePickerStyles/DatePickerStyles'
import FileUploader from 'components/Uploader/FileUpload.js'
import {
  AlertTexts,
  StyledAlerts,
} from '../../../../../../components/UIComponents/FormStyles'
import InfoIcon from '../../../../../../components/icons/InfoIcon'

import Button from 'components/Button'
import Drawer from 'components/Drawer'
import NewCorporate from 'modules/Corporate/NewCorporate'
import { getCorporateList, getSectorMaster } from 'modules/Corporate/actions'
import { FooterFlex } from 'modules/Students/Partials/StudentsBulkUpload/Style/style'
import { useDispatch } from 'react-redux'
import { systemConfig } from '../../../../../../utils/config'
import {
  AddNewCorporate,
  LabelDiv,
  LabelDivWithPopup,
  NumberDiv,
  NumberDivision,
  NumberInputDiv,
} from './style'
const internShipDurationOption = []
for (let i = 1; i <= 12; i++) {
  if (i === 1) {
    internShipDurationOption.push({
      label: `${i} Month`,
      value: i * 30,
    })
  } else {
    internShipDurationOption.push({
      label: `${i} Months`,
      value: i * 30,
    })
  }
}

const JobDetails = ({
  setLabelName,
  functionData,
  functionApi,
  roleFormData,
  setRoleFormData,
  rolesList,
  roleApi,
  companyList,
  companiesApi,
  setSave,
  roleForm,
  dateFormat,
  Form,
  setSelectedType,
  isEditRoleOnView,
  eligibleCandidatesMetrics,
  setQualificationError,
  gigsErr,
  setGigsErr,
  experienceErr,
  setExperienceErr,
  setLengthError,
  draft,
  jobDetailsForm,
  setInitialLoading,
  params,
  jdFile,
  getRolesListData,
  getMasterSearchApi,
  setFunctionData,
  stepStatus,
  triggerBack,
  previewData,
  setPreviewData,
}) => {
  const isSecondEdit = !!roleFormData?.republishedDate;
  const [key, setKey] = useState(0)
  const dispatch = useDispatch()
  const [searchValue, setSearchValue] = useState('')
  const [jobOptions, setJobOptions] = useState([])
  const [designationSearch, setDesignationSearch] = useState('')
  const [showOtherInputFunction, setShowOtherInputFunction] = useState(false)
  const [addNewCorporate, setAddNewCorporate] = useState(false)
  const [companyListOption, setCompanyListOption] = useState([])
  const [sectorMaster, setSectorMaster] = useState([])

  useEffect(() => {
    if (functionData) {
      setOptions(
        functionData
          ? [...functionData, { name: 'Others', id: 'OTHERS', is_active: true }]
          : []
      )
    }
    // if (companyList) {
    //   setCompanyListOption(
    //     companyList || []
    //   )
    // }
  }, [functionData, companyList])
  const [options, setOptions] = useState(
    functionData
      ? [...functionData, { name: 'Other', id: 'OTHERS', is_active: true }]
      : []
  )
  useEffect(() => {
    setQualificationError('')
  }, [])

  useEffect(() => {
    fetchSectormaster()
    fetchCompanyMaster('')
  }, [])

  const fetchCompanyMaster = async search => {
    let responce = await dispatch(getCorporateList(search, 0))

    setCompanyListOption(responce?.companymasterData?.result)
  }

  const fetchSectormaster = async search => {
    let responce = await dispatch(getSectorMaster(search))

    let list = [...responce?.result, { name: search, id: 'OTHERS' }]
    const seen = new Set()
    const filterData = list?.filter(item => {
      const isDuplicate = seen?.has(item?.name)
      seen?.add(item?.name)
      return !isDuplicate
    })
    setSectorMaster([...filterData])
  }
  const [loading, setLoading] = useState(false)

  const populateData = async jobDetailsForm => {
    if (jobDetailsForm?.workStyle) {
      console.log(jobDetailsForm?.workStyle?.toUpperCase(),'workstyle')
      roleForm.setFieldsValue({
        jobDetails: {
          workStyle: jobDetailsForm?.workStyle?.toUpperCase(),
        },
      })
      setRoleFormData({
        ...roleFormData,
        jobDetails: {
          ...roleFormData?.jobDetails,
          workStyle: jobDetailsForm?.workStyle?.toUpperCase(),
        },
      })
      // await onChangeHandler(
      //   jobDetailsForm?.workStyle?.toUpperCase(),
      //   'workStyle'
      // )
    } else {
      await onChangeHandler('', 'workStyle')
    }
    if (jobDetailsForm?.employmentType) {
      await onChangeHandler(
        jobDetailsForm?.employmentType?.toUpperCase() == 'CONTRACT'
          ? 'CONTRACT'
          : 'ONROLL',
        'employmentType'
      )
      if (jobDetailsForm?.employmentType?.toUpperCase() == 'CONTRACT') {
        roleFormData.jobDetails.employmentType = 'CONTRACT'
      } else {
        roleFormData.jobDetails.employmentType = 'ONROLL'
      }
    }

    if (jobDetailsForm?.jobTypeLevel) {
      const experienceRequired = jobDetailsForm?.['Experience required']
      const jobTypeData = {
        name: jobDetailsForm?.jobTypeLevel?.toUpperCase(),
        value:
          jobDetailsForm?.jobTypeLevel?.toUpperCase() == 'EXPERIENCED'
            ? experienceRequired
            : '',
        isJD: true,
      }
      await onChangeHandler(jobTypeData, 'jobTypeLevels')
    }
    if (jobDetailsForm?.jobType) {
      const partTimeDatas = [
        'PARTTIME',
        'PART_TIME',
        'PART-TIME',
        'PART.TIME',
        'PART TIME',
      ]
      const jobTypeValue = partTimeDatas?.includes(
        jobDetailsForm?.jobType?.toUpperCase()
      )
        ? 'PART_TIME'
        : 'FULL_TIME'
      await onChangeHandler(jobTypeValue, 'jobType')
    } else {
      await onChangeHandler('FULL_TIME', 'jobType')
    }
    if (jobDetailsForm?.jobdescription || jobDetailsForm?.JobDuties) {
      const jobDescription = jobDetailsForm?.jobdescription
      const jobDuties = jobDetailsForm?.JobDuties
      let jobDescriptionValue = ''

      // Check if the job description is an array
      if (Array.isArray(jobDescription)) {
        jobDescriptionValue = jobDescription
          .map(item => `${item}`)
          .join('<br />')
      }
      // Check if the job description is a string
      else if (typeof jobDescription === 'string') {
        jobDescriptionValue = `${jobDescription}`
      }
      // Check if the job description is an object
      else if (typeof jobDescription === 'object' && jobDescription !== null) {
        jobDescriptionValue = Object.entries(jobDescription)
          .map(([sectionTitle, items]) => {
            if (Array.isArray(items)) {
              return (
                `${sectionTitle}:<br />` +
                items.map(item => `${item}`).join('<br />')
              )
            } else if (typeof items === 'string') {
              return `${sectionTitle}:<br />${items}`
            } else if (typeof items === 'object' && items !== null) {
              return `${sectionTitle}:<br /><pre>${JSON.stringify(
                items,
                null,
                2
              )}</pre>`
            }
            return ''
          })
          .join('<br /><br />')
      }

      // Handle job duties and concatenate
      let jobDutiesValue = ''
      if (Array.isArray(jobDuties)) {
        jobDutiesValue = jobDuties.map(item => `${item}`).join('<br />')
      } else if (typeof jobDuties === 'string') {
        jobDutiesValue = `${jobDuties}`
      }

      // Concatenate job description and job duties with line breaks
      jobDescriptionValue += jobDutiesValue
        ? `<br /><br />${jobDutiesValue}`
        : ''

      await roleForm.setFieldsValue({
        jobDetails: {
          description: jobDescriptionValue,
        },
      })

      roleFormData.jobDetails.description = jobDescriptionValue

      await onChangeHandler(jobDescriptionValue, 'description')
    }

    if (jobDetailsForm?.jobCategory) {
      let gigsDurationValue = []
      if (jobDetailsForm?.jobCategory?.toUpperCase() == 'GIGS') {
        if (jobDetailsForm?.gigsduration?.length == 2) {
          // Extracting years and months from gigsduration
          const firstDuration = jobDetailsForm?.gigsduration?.[0]
          const secondDuration = jobDetailsForm?.gigsduration?.[1]

          const durationFirstYear = Math.floor(firstDuration) // Integer part, e.g. 1 from 1.4
          const durationFirstMonth = Math.round(
            (firstDuration - durationFirstYear) * 10
          ) // Decimal part, e.g. 4 from 1.4

          const durationSecondYear = Math.floor(secondDuration) // Integer part, e.g. 3 from 3.5
          const durationSecondMonth = Math.round(
            (secondDuration - durationSecondYear) * 10
          ) // Decimal part, e.g. 5 from 3.5

          gigsDurationValue = [
            Number(durationFirstYear)?.toFixed(1),
            Number(durationFirstMonth)?.toFixed(1),
            Number(durationSecondYear)?.toFixed(1),
            Number(durationSecondMonth)?.toFixed(1),
          ]

          await onChangeHandler('GIGS', 'jobCategory')

          await onChangeHandler(durationFirstYear, 'durationFirstYear')
          await onChangeHandler(durationFirstMonth, 'durationFirstMonth')
          await onChangeHandler(durationSecondYear, 'durationSecondYear')
          await onChangeHandler(durationSecondMonth, 'durationSecondMonth')

          roleFormData.jobDetails.durationFirstYear = durationFirstYear
          roleFormData.jobDetails.durationFirstMonth = durationFirstMonth
          roleFormData.jobDetails.durationSecondYear = durationSecondYear
          roleFormData.jobDetails.durationSecondMonth = durationSecondMonth

          roleForm.setFieldValue(
            ['jobDetails', 'durationFirstYear'],
            durationFirstYear || 0
          )
          roleForm.setFieldValue(
            ['jobDetails', 'durationFirstMonth'],
            durationFirstMonth || 0
          )
          roleForm.setFieldValue(
            ['jobDetails', 'durationSecondYear'],
            durationSecondYear || 0
          )
          roleForm.setFieldValue(
            ['jobDetails', 'durationSecondMonth'],
            durationSecondMonth || 0
          )
        } else {
          const durationFirstYear = 0
          const durationFirstMonth = 0
          const durationSecondYear = 0
          const durationSecondMonth = 0
          await onChangeHandler('GIGS', 'jobCategory')

          await onChangeHandler(durationFirstYear, 'durationFirstYear')
          await onChangeHandler(durationFirstMonth, 'durationFirstMonth')
          await onChangeHandler(durationSecondYear, 'durationSecondYear')
          await onChangeHandler(durationSecondMonth, 'durationSecondMonth')

          roleFormData.jobDetails.durationFirstYear = durationFirstYear
          roleFormData.jobDetails.durationFirstMonth = durationFirstMonth
          roleFormData.jobDetails.durationSecondYear = durationSecondYear
          roleFormData.jobDetails.durationSecondMonth = durationSecondMonth

          roleForm.setFieldValue(
            ['jobDetails', 'durationFirstYear'],
            durationFirstYear || 0
          )
          roleForm.setFieldValue(
            ['jobDetails', 'durationFirstMonth'],
            durationFirstMonth || 0
          )
          roleForm.setFieldValue(
            ['jobDetails', 'durationSecondYear'],
            durationSecondYear || 0
          )
          roleForm.setFieldValue(
            ['jobDetails', 'durationSecondMonth'],
            durationSecondMonth || 0
          )
        }
      }

      if (jobDetailsForm.jobCategory?.toUpperCase() != 'GIGS') {
        const jobTypeData = {
          name: jobDetailsForm.jobCategory?.toUpperCase(),
          value:
            jobDetailsForm?.jobCategory?.toUpperCase() == 'INTERNSHIP'
              ? Array.isArray(jobDetailsForm?.internshipDuration)
                ? jobDetailsForm?.internshipDuration?.[0]
                : Number(jobDetailsForm?.internshipDuration)
              : '',
          isJD: true,
        }
        await onChangeHandler(jobTypeData, 'jobCategory')
      }
      roleFormData.jobDetails.internshipDuration = Array.isArray(
        jobDetailsForm?.internshipDuration
      )
        ? jobDetailsForm?.internshipDuration?.[0]
        : Number(jobDetailsForm?.internshipDuration)
      roleFormData.jobDetails.jobCategory =
        jobDetailsForm.jobCategory?.toUpperCase()
      roleFormData.jobDetails.gigsDuration =
        gigsDurationValue?.length > 1 ? gigsDurationValue : [0]
    } else {
      await onChangeHandler('', 'jobCategory')
    }

    if (jobDetailsForm?.ApplicationEndDate) {
      const futureDateCheck = moment(
        jobDetailsForm.ApplicationEndDate,
        [
          'DD/MM/YYYY',
          'DD-MM-YYYY',
          'DD MMMM YYYY',
          'YYYY-MM-DD',
          'YYYY-MM-DDTHH:mm:ss',
          'DD/MM/YYYY HH:mm',
          'DD-MM-YYYY HH:mm',
        ],
        true
      )

      if (!futureDateCheck.isValid()) {
        return
      }

      if (futureDateCheck.isBefore(moment())) {
        return
      }
      const possibleFormats = [
        'DD/MM/YYYY',
        'DD-MM-YYYY',
        'DD MMMM YYYY',
        'YYYY-MM-DD',
      ]

      const applicationEndDate = moment(
        jobDetailsForm?.ApplicationEndDate,
        possibleFormats,
        true
      )
      if (applicationEndDate.format('DD/MM/YYYY') != 'Invalid date') {
        const currentDate = moment().startOf('day')
        if (applicationEndDate.isBefore(currentDate)) {
          console.error('Application end date should not be in the past!')
        }
        roleFormData.jobDetails.endDate = applicationEndDate || ''
        roleForm.setFieldValue(
          ['jobDetails', 'endDate'],
          applicationEndDate || ''
        )
      }
    }

    if (jobDetailsForm?.title) {
      const newTitleData = await getRolesListData(
        setLoading,
        `pageLimit=50&pageNo=1&search=${jobDetailsForm?.title?.trim()}`
      )
      setDesignationSearch(jobDetailsForm?.title?.trim())
      const matchedTitle = []
      newTitleData?.data?.list.find(item => {
        if (item?.name?.toLowerCase() == jobDetailsForm?.title?.toLowerCase()) {
          matchedTitle.push(item)
        }
      })
      if (matchedTitle?.length) {
        const newTitle = {
          name: matchedTitle[0]?.name,
          id: matchedTitle[0]?.id,
        }
        setRoleFormData({
          ...roleFormData,
          jobDetails: {
            ...roleFormData?.jobDetails,
            jobTitle: newTitle?.name,
            designationId: newTitle?.id === 'OTHERS' ? '' : newTitle?.id,
          },
        })
        roleFormData.jobDetails.jobTitle = newTitle.name
        roleForm.setFieldsValue({
          jobDetails: {
            jobTitle: newTitle.name,
            designationId: newTitle?.id === 'OTHERS' ? '' : newTitle?.id,
          },
        })
      } else {
        const newTitle = {
          name: jobDetailsForm?.title,
          id: 'OTHERS',
        }
        setRoleFormData({
          ...roleFormData,
          jobDetails: {
            ...roleFormData?.jobDetails,
            jobTitle: newTitle.name,
            designationId: newTitle?.id === 'OTHERS' ? '' : newTitle?.id,
          },
        })
        roleFormData.jobDetails.jobTitle = newTitle.name
        roleForm.setFieldsValue({
          jobDetails: {
            jobTitle: newTitle.name,
            designationId: newTitle?.id === 'OTHERS' ? '' : newTitle?.id,
          },
        })
      }
      roleApi('')
      fetchRoleData('')
    }

    if (jobDetailsForm?.function) {
      let payLoad = systemConfig.function
      payLoad.q = jobDetailsForm?.function?.trim()
      const data = await getMasterSearchApi('function', payLoad)
      if (data?.length) {
        // if (data?.length == 1) {
        await setRoleFormData({
          ...roleFormData,
          jobDetails: {
            ...roleFormData?.jobDetails,
            jobFunction: data[0]?.name,
            functionId: data[0]?.id,
          },
        })
        await roleForm.setFieldValue(['jobDetails', 'functionId'], data[0]?.id)
        await roleForm.setFieldValue(
          ['jobDetails', 'jobFunction'],
          data[0]?.name
        )
        functionApi()
        // } else {
        //   setFunctionData(data)
        //   roleFormData.jobDetails.jobFunction = ''
        //   roleFormData.jobDetails.otherJobFunction = ''
        //   roleFormData.jobDetails.functionId = ''
        //   roleForm.setFieldValue(['jobDetails', 'functionId'], '')
        //   roleForm.setFieldValue(['jobDetails', 'otherJobFunction'], '')
        //   roleForm.setFieldValue(['jobDetails', 'jobFunction'], '')
        // }
      } else {
        setShowOtherInputFunction(true)
        await setRoleFormData({
          ...roleFormData,
          jobDetails: {
            ...roleFormData?.jobDetails,
            jobFunction: 'OTHERS',
            otherJobFunction: jobDetailsForm?.function?.trim() || '',
            functionId: '',
          },
        })

        await roleForm.setFieldValue(['jobDetails', 'functionId'], '')
        await roleForm.setFieldValue(
          ['jobDetails', 'otherJobFunction'],
          jobDetailsForm?.function?.trim() || ''
        )
        await roleForm.setFieldValue(['jobDetails', 'jobFunction'], 'OTHERS')
        await functionApi()
      }
    } else {
      await setRoleFormData({
        ...roleFormData,
        jobDetails: {
          ...roleFormData?.jobDetails,
          jobFunction: '',
          otherJobFunction: '',
          functionId: '',
        },
      })
      await roleForm.setFieldValue(['jobDetails', 'functionId'], '')
      await roleForm.setFieldValue(['jobDetails', 'otherJobFunction'], '')
      await roleForm.setFieldValue(['jobDetails', 'jobFunction'], '')
      await functionApi()
    }
  }
  useLayoutEffect(() => {
    const fetchData = async () => {
      if (
        jdFile?.length &&
        jobDetailsForm &&
        !params?.roleId &&
        !stepStatus?.job &&
        !triggerBack
      ) {
        setLoading(true)
        await populateData(jobDetailsForm)
        setLoading(false)
      }
    }
    fetchData()
  }, [jobDetailsForm])

  const RadioOptions1 = [
    {
      id: 2,
      label: 'Placement',
      value: 'PLACEMENT',
    },
    {
      id: 1,
      label: 'Internship',
      value: 'INTERNSHIP',
    },

    {
      id: 3,
      label: 'Apprenticeship',
      value: 'APPRENTICESHIP',
    },
    {
      id: 3,
      label: 'Gigs',
      value: 'GIGS',
    },
  ]
  const RadioOptions2 = [
    {
      id: 2,
      label: 'Fresher Only',
      value: 'ENTRY',
    },
    {
      id: 3,
      label: 'Experienced Only',
      value: 'EXPERIENCED',
    },
    {
      id: 1,
      label: 'Both',
      value: 'BOTH',
    },
  ]
  const RadioOptions3 = [
    {
      id: 1,
      label: 'Remote',
      value: 'REMOTE',
    },
    {
      id: 2,
      label: 'Hybrid',
      value: 'HYBRID',
    },
    {
      id: 3,
      label: 'Onsite',
      value: 'ONSITE',
    },
  ]
  const clearJobTitle = () => {
    setRoleFormData({
      ...roleFormData,
      jobDetails: {
        ...roleFormData?.jobDetails,
        jobFunction: '',
      },
    })

    setOptions(
      functionData
        ? [...functionData, { name: 'Other', id: 'OTHERS', is_active: true }]
        : []
    )
  }
  const onChangeHandler = async (value, fieldName) => {
    setSave(false)

    if (previewData) {
      if (fieldName == 'endTime') {
        const endTimeDayjs = dayjs(value, 'HH:mm')
        roleFormData.jobDetails.endTime = endTimeDayjs
        setRoleFormData({
          ...roleFormData,
          jobDetails: {
            ...roleFormData.jobDetails,
            endTime: endTimeDayjs,
          },
        })
      }
      if (fieldName === 'endDate' || fieldName === 'endTime') {
        const endDateValue =
          fieldName === 'endDate' ? value : roleFormData?.jobDetails?.endDate

        let endTimeValue =
          fieldName === 'endTime' ? value : roleFormData?.jobDetails?.endTime
        
        // Convert dayjs object to string format if needed
        if (endTimeValue && typeof endTimeValue === 'object' && endTimeValue.format) {
          endTimeValue = endTimeValue.format('HH:mm')
        }

        const formattedDate = endDateValue
          ? dateConversion({
              date: endDateValue,
              convertTo: 'YYYY-MM-DD',
            })
          : null

        const formattedTime = timeCheck(endTimeValue)

        console.log('🕐 End Time Debug:', {
          fieldName,
          rawEndTimeValue: fieldName === 'endTime' ? value : roleFormData?.jobDetails?.endTime,
          convertedEndTimeValue: endTimeValue,
          formattedTime,
          formattedDate
        })

        const endDate = formattedDate && formattedTime
          ? `${formattedDate}T${formattedTime}:00.000Z`
          : formattedDate
          ? `${formattedDate}T23:55:00.000Z`
          : null

        previewData.endDate = endDate
      }

      if (fieldName === 'startDate') {
        const startDate = value
          ? moment(value).startOf('day').toISOString()
          : moment().startOf('day').toISOString()

        previewData.startDate = startDate
      }

      if (fieldName == 'companyWebsite') {
        previewData.company.website = value ? value : ''
      }
      if (fieldName == 'description') {
        previewData.description = value ? value : ''
      }
      if (fieldName == 'companyDescription') {
        previewData.company = { description: value ? value : '' }
      }
      if (fieldName == 'workStyle') {
        previewData.workStyle = value ? value : ''
      }
      // if (fieldName === 'jobTypeLevels') {
      //   previewData.jobTypeLevels = ['EXPERIENCED'];
      // }
      // if (fieldName == 'jobTypeLevels') {
      //   previewData.jobTypeLevels = value ? value : ''
      // }
    }

    if (
      (fieldName === 'jobTypeLevels' && value == 'BOTH') ||
      (fieldName === 'jobTypeLevels' && value == 'EXPERIENCED') ||
      (fieldName === 'jobTypeLevels' && value == 'ENTRY') ||
      (value?.isJD && ['BOTH', 'EXPERIENCED', 'ENTRY'].includes(value.name))
    ) {
      roleFormData.jobDetails.firstYear = value?.value?.[0] ?? 0
      roleFormData.jobDetails.firstMonth = value?.value?.[1] ?? 0
      roleFormData.jobDetails.secondYear = value?.value?.[2] ?? 0
      roleFormData.jobDetails.secondMonth = value?.value?.[3] ?? 0
      roleFormData.jobDetails.jobTypeLevels = value?.isJD
        ? value.name
        : value ?? ''
      roleForm.setFieldsValue({
        jobDetails: {
          [fieldName]: value?.isJD ? value.name : value,
          firstYear: value?.value?.[0] ?? 0,
          firstMonth: value?.value?.[1] ?? 0,
          secondYear: value?.value?.[2] ?? 0,
          secondMonth: value?.value?.[3] ?? 0,
        },
      })
      setExperienceErr('')
      if (previewData?.jobTypeLevels) {
        setPreviewData({
          ...previewData,
          jobTypeLevels: value ? [value] : [],
        })
      }
    }

    if (fieldName == 'jobType') {
      roleForm.setFieldsValue({
        jobDetails: {
          jobType: value,
        },
      })
      roleFormData.jobDetails.jobType = value
      setRoleFormData({
        ...roleFormData,
        jobDetails: {
          ...roleFormData?.jobDetails,
          jobType: value,
        },
      })
    }
    if (fieldName == 'startDate') {
      roleForm.setFieldsValue({
        jobDetails: {
          endDate: '',
        },
      })
    }
    if (fieldName == 'workStyle') {
      roleForm.setFieldsValue({
        jobDetails: {
          workStyle: value,
        },
      })
      setRoleFormData({
        ...roleFormData,
        jobDetails: {
          ...roleFormData?.jobDetails,
          workStyle: value,
        },
      })
    }
    if (fieldName == 'employmentType') {
      roleForm.setFieldsValue({
        jobDetails: {
          employmentType: value,
        },
      })
    }

    if (
      fieldName == 'description' &&
      (value == '<p><br></p>' || value?.trim()?.length > 0)
    ) {
      roleForm.setFieldsValue({
        description: value || '',
      })
      setRoleFormData({
        ...roleFormData,
        jobDetails: {
          ...roleFormData?.jobDetails,
          [fieldName]: value || '',
        },
      })
    }

    if (fieldName == 'jobFunction' && roleFormData?.jobDetails?.jobTitle) {
      clearJobTitle()
    }

    if (
      (fieldName == 'description' && value == ' ') ||
      (fieldName == 'description' && value == '<p><br></p>') ||
      (fieldName == 'description' &&
        /^\s*$/.test(value.replace(/<p>|<\/p>/g, '').replace(/&nbsp;/g, ' ')))
    ) {
      roleForm.setFieldsValue({
        jobDetails: {
          description: '',
        },
      })
      setRoleFormData({
        ...roleFormData,
        jobDetails: {
          ...roleFormData?.jobDetails,
          [fieldName]: '',
        },
      })
    }

    if (fieldName === 'jobTypeLevel' && value?.includes('INTERN')) {
      setLabelName('Stipend')
      roleForm.setFieldsValue({
        jobDetails: {
          internshipStartDate: '',
          internshipEndDate: '',
        },
      })
      setRoleFormData({
        ...roleFormData,
        yearOfExperience: [0],
      })
    }

    if (fieldName === 'jobTypeLevel' && !value?.includes('INTERN')) {
      roleForm.setFieldsValue({
        jobDetails: {
          internshipStartDate: '',
          internshipEndDate: '',
        },
      })
      setLabelName('Stipend')
    }

    if (fieldName === 'companyName') {
      if (value == 'OTHERS') {
        setRoleFormData({
          ...roleFormData,
          jobDetails: {
            ...roleFormData?.jobDetails,
            otherCompanyName: '',
            [fieldName]: value,
            companyId: '',
            companyWebsite: '',
            otherLinks: [{ link: '' }],
            companyDescription: '',
          },
        })
        roleForm.setFieldsValue({
          jobDetails: {
            otherCompanyName: '',
            [fieldName]: value,
            companyId: '',
            companyWebsite: '',
            otherLinks: [{ link: '' }],
            companyDescription: '',
          },
        })
        setKey(key + 1)
      } else {
        const selectedCompany = companyList.find(item => item.id === value)
        const selectedOtherLinks = selectedCompany?.otherLinks?.map(item => {
          return {
            link: item,
          }
        })

        setKey(key + 1)
        setRoleFormData(prevData => ({
          ...prevData,
          jobDetails: {
            ...prevData?.jobDetails,
            [fieldName]: value,
            companyId: value,
            companyWebsite:
              value && selectedCompany?.website ? selectedCompany?.website : '',
            companyDescription:
              value && selectedCompany?.description
                ? `<p>${selectedCompany?.description}</p>`
                : '',
            otherLinks:
              selectedOtherLinks?.length > 0
                ? selectedOtherLinks
                : [{ link: '' }],
            sector: selectedCompany?.sector ? selectedCompany?.sector : '',
            sectorId: selectedCompany?.sectorId
              ? selectedCompany?.sectorId
              : '',
          },
        }))
        roleForm.setFieldsValue({
          jobDetails: {
            [fieldName]: value ?? '',
            companyWebsite: value ? selectedCompany?.website : '',
            companyDescription:
              value && selectedCompany?.description
                ? `<p>${selectedCompany?.description}</p>`
                : '',
            otherLinks:
              selectedOtherLinks?.length > 0
                ? selectedOtherLinks
                : [{ link: '' }],
            sector: selectedCompany?.sector ? selectedCompany?.sector : '',
            sectorId: selectedCompany?.sectorId
              ? selectedCompany?.sectorId
              : '',
          },
        })
      }
      fetchCompanyMaster()
    } else if (fieldName == 'jobFunction') {
      if (value == 'OTHERS') {
        setShowOtherInputFunction(true)
        setRoleFormData({
          ...roleFormData,
          jobDetails: {
            ...roleFormData?.jobDetails,
            [fieldName]: value,
            functionId: '',
          },
        })
        roleForm.setFieldsValue({
          jobDetails: {
            [fieldName]: value,
            otherJobFunction: '',
          },
        })
      } else {
        const selectedTitle = options.find(item => item.id === value)
        setShowOtherInputFunction(false)
        setRoleFormData({
          ...roleFormData,
          jobDetails: {
            ...roleFormData?.jobDetails,
            [fieldName]: selectedTitle?.name,
            functionId: selectedTitle?.id,
          },
        })
      }
      functionApi()
    } else if (fieldName === 'jobTitle' && value?.trim()) {
      const selectedTitle = jobOptions.find(item => item?.name === value)
      if (selectedTitle) {
        setRoleFormData({
          ...roleFormData,
          jobDetails: {
            ...roleFormData?.jobDetails,
            [fieldName]: selectedTitle?.name,
            designationId:
              selectedTitle?.id === 'OTHERS' ? '' : selectedTitle?.id,
          },
        })
      }
      roleApi()
    } else if (fieldName == 'jobCategory') {
      let newValue = ''
      if (value?.isJD) {
        newValue = value?.name
      } else {
        newValue = value
      }

      setRoleFormData(prevState => ({
        ...prevState,
        ctc: {
          ...prevState?.ctc,
          ['isNoStipend']: true,
          ['isAdditional']: false,
          ['isBond']: false,
          ['isRange']: false,
        },
        jobDetails: {
          ...prevState?.jobDetails,
          [fieldName]: newValue,
          internshipDuration: value?.value || null,
          durationFirstMonth: 0,
          durationFirstYear: 0,
          durationSecondMonth: 0,
          durationSecondYear: 0,
        },
      }))
      if (newValue == 'INTERNSHIP') {
        setRoleFormData(prevState => ({
          ...prevState,
          ctc: {
            ...prevState?.ctc,
            period: 'MONTHLY',
          },
        }))
      }

      setGigsErr('')
      roleForm.setFieldsValue({
        jobDetails: {
          [fieldName]: newValue,
          internshipDuration: value?.value || null,
          durationFirstMonth: 0,
          durationFirstYear: 0,
          durationSecondMonth: 0,
          durationSecondYear: 0,
        },
      })
      if (value == 'INTERNSHIP' || value == 'APPRENTICESHIP') {
        setSelectedType(value)
        setLabelName('Stipend & Job Location')
      } else {
        setSelectedType(value)
        setLabelName('CTC & Job Location')
      }
    } else {
      setRoleFormData({
        ...roleFormData,
        jobDetails: { ...roleFormData?.jobDetails, [fieldName]: value },
      })
      if (
        roleFormData?.jobDetails?.jobCategory == 'GIGS' ||
        roleFormData?.jobDetails?.jobTypeLevels == 'BOTH' ||
        roleFormData?.jobDetails?.jobTypeLevels == 'EXPERIENCED'
      ) {
        validationForJobCategory(fieldName, value)
      }

      if (
        ['firstYear', 'firstMonth', 'secondYear', 'secondMonth']?.includes(
          fieldName
        )
      ) {
        const data = {
          ...roleFormData,
          jobDetails: { ...roleFormData?.jobDetails, [fieldName]: value },
        }
        if (previewData?.jobTypeLevels) {
          // Get values from roleFormData or from the current value, as appropriate
          const fy = data?.jobDetails?.firstYear || 0;
          const fm = data?.jobDetails?.firstMonth || 0;
          const sy = data?.jobDetails?.secondYear || 0;
          const sm = data?.jobDetails?.secondMonth || 0;
        
          // Helper to combine year and month
          const combineYearMonth = (year, month) => {
            if (year && month) return Number(`${year}.${month}`);
            if (year) return Number(year);
            if (month) return Number(`0.${month}`);
            return 0;
          };
        
          const yearOfExperience = [
            combineYearMonth(fy, fm),
            combineYearMonth(sy, sm)
          ];
        
          setPreviewData({
            ...previewData,
            yearOfExperience: yearOfExperience,
          });
        }
        eligibleCandidatesMetrics(data)
      } else if ((fieldName = 'jobTypeLevels' && !value?.isJD)) {
        const data = {
          ...roleFormData,
          jobDetails: { ...roleFormData?.jobDetails, [fieldName]: value },
        }
        eligibleCandidatesMetrics(data)
      } else if ((fieldName = 'jobTypeLevels' && value?.isJD)) {
        const data = {
          ...roleFormData,
          jobDetails: { ...roleFormData?.jobDetails, [fieldName]: value.name },
        }
        eligibleCandidatesMetrics(data)
      }
    }
  }

  const validationForJobCategory = (fieldName, value) => {
    let duration = [
      'durationFirstYear',
      'durationFirstMonth',
      'durationSecondYear',
      'durationSecondMonth',
    ]
    let selectedField = duration?.includes(fieldName)
    let firstYearFieldName = selectedField ? 'durationFirstYear' : 'firstYear'
    let firstMonthFieldName = selectedField
      ? 'durationFirstMonth'
      : 'durationSecondYear'
    let secondYearFieldName = selectedField
      ? 'durationSecondYear'
      : 'secondYear'
    let secondMonthFieldName = selectedField
      ? 'durationSecondMonth'
      : 'secondMonth'

    if (
      [
        firstYearFieldName,
        firstMonthFieldName,
        secondYearFieldName,
        secondMonthFieldName,
      ]?.includes(fieldName)
    ) {
      const firstYear =
        firstYearFieldName == fieldName
          ? value
          : roleForm.getFieldValue(['jobDetails', firstYearFieldName])
      const firstMonth =
        firstMonthFieldName == fieldName
          ? value
          : roleForm.getFieldValue(['jobDetails', firstMonthFieldName])
      const secondYear =
        secondYearFieldName == fieldName
          ? value
          : roleForm.getFieldValue(['jobDetails', secondYearFieldName])
      const secondMonth =
        secondMonthFieldName == fieldName
          ? value
          : roleForm.getFieldValue(['jobDetails', secondMonthFieldName])
      if (value && roleFormData?.jobDetails['jobCategory'] == 'GIGS') {
        const firstTotalMonths = Number(firstYear) * 12 + Number(firstMonth)
        const secondTotalMonths = Number(secondYear) * 12 + Number(secondMonth)
        if (secondTotalMonths) {
          if (firstTotalMonths > secondTotalMonths) {
            if (selectedField) {
              setGigsErr('Please enter a valid duration')
            } else {
              setExperienceErr('Please enter the valid experience')
            }
          } else if (selectedField) {
            setGigsErr('')
          } else {
            setExperienceErr('')
          }
        }
        if (secondTotalMonths === 0 && firstTotalMonths === 0) {
          if (selectedField) {
            setGigsErr('Please enter a duration')
          } else {
            setExperienceErr('Please enter the experience')
          }
        } else if (secondTotalMonths === 0) {
          if (selectedField) {
            setGigsErr('Please enter a valid duration')
          } else {
            setExperienceErr('Please enter the valid experience')
          }
        }
        if (
          (fieldName == firstMonthFieldName ||
            fieldName == secondMonthFieldName) &&
          (value < 0 || value > 11)
        ) {
          if (selectedField) {
            setGigsErr('Value must be between 0 and 11')
          } else {
            setExperienceErr('Value must be between 0 and 11')
          }
        }
      } else if (selectedField) {
        setGigsErr('')
      } else {
        setExperienceErr('')
      }
    }
  }

  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  const delayFunctionToFetch = useCallback(
    debounce(data => {
      functionApi(data)
    }, 500),
    []
  )
  const fetchCompanyData = useCallback(
    debounce(data => {
      fetchCompanyMaster(data)
    }, 500),
    []
  )
  const fetchRoleData = useCallback(
    debounce(data => {
      if (data?.trim() !== '' && designationSearch != data) {
        roleApi(data)
        setDesignationSearch(data)
      }
    }, 1500)
  )

  useEffect(() => {
    // if (currentStep === jobDetailsStepNum) {
    companiesApi()
    roleApi()
    functionApi()
    // }
    setTimeout(() => {
      setInitialLoading(false)
    }, 1000)
  }, [])

  useEffect(() => {
    if (designationSearch) {
      const lowercaseDesignationSearch = designationSearch?.toLowerCase()
      if (designationSearch?.length > 0) {
        if (
          !jobOptions?.some(option => {
            const lowercaseOptionName = option?.name?.toLowerCase()?.trim()
            return lowercaseOptionName === lowercaseDesignationSearch?.trim()
          })
        ) {
          let list = [...jobOptions, { name: designationSearch, id: 'OTHERS' }]
          const seen = new Set()
          const filterData = list?.filter(item => {
            const isDuplicate = seen?.has(item?.name)
            seen?.add(item?.name)
            return !isDuplicate
          })
          setJobOptions([...filterData])
        }
      }
    }
  }, [designationSearch, jobOptions])

  useEffect(() => {
    if (rolesList?.list) {
      let list = rolesList?.list
      const seen = new Set()
      const filterData = list?.filter(item => {
        const isDuplicate = seen?.has(item?.name)
        seen?.add(item?.name)
        return !isDuplicate
      })
      setJobOptions([...filterData])
    }
  }, [rolesList?.list])

  const onChangeLinks = (value, index) => {
    const newOtherLinks = [...roleFormData.jobDetails.otherLinks]

    newOtherLinks[index] = {
      ...newOtherLinks[index],
      link: value,
    }
    setRoleFormData({
      ...roleFormData,
      jobDetails: { ...roleFormData?.jobDetails, otherLinks: newOtherLinks },
    })
  }
  const [file, setFile] = useState(roleFormData?.jobDetails?.jobRoleDocs || [])
  const initialFileURL =
    roleFormData?.jobDetails?.jobRoleDocs?.map(item => item.url) || []
  const [fileURL, setFileURL] = useState(initialFileURL)

  useEffect(() => {
    setRoleFormData({
      ...roleFormData,
      jobDetails: {
        ...roleFormData?.jobDetails,
        jobRoleDocs: file,
        jobRolesUrl: fileURL,
      },
    })
  }, [file, fileURL])

  const handleFileRemove = indexToRemove => {
    const updatedFile = file.filter((_, index) => index !== indexToRemove)
    const updatedFileURL = fileURL.filter((_, index) => index !== indexToRemove)
    setFile(updatedFile)
    setFileURL(updatedFileURL)
  }

  const handleRemove = (remove, index) => {
    remove(index)

    let data = [...(roleFormData?.jobDetails?.otherLinks || [])]
    data.splice(index, 1)
    setRoleFormData({
      ...roleFormData,
      jobDetails: { ...roleFormData?.jobDetails, otherLinks: data },
    })
  }
  const handleSectorSelect = (data, Options) => {
    if (Options?.name) {
      setRoleFormData({
        ...roleFormData,
        jobDetails: {
          ...roleFormData?.jobDetails,
          sector: Options?.name,
          sectorId: Options?.id,
        },
      })
      if (previewData?.company) {
        setPreviewData({
          ...previewData,
          company: {
            ...previewData?.company,
            sector: Options?.name,
          },
        })
      }

      roleForm.setFieldsValue({
        jobDetails: {
          sector: Options?.name,
          sectorId: Options?.id,
        },
      })
    } else {
      setRoleFormData({
        ...roleFormData,
        jobDetails: {
          ...roleFormData?.jobDetails,
          sector: '',
          sectorId: '',
        },
      })
      roleForm.setFieldsValue({
        jobDetails: {
          sector: '',
          sectorId: '',
        },
      })
    }
  }
  const onSetCompanyData = async data => {
    let companyData = data?.data?.data
    setKey(key + 1)
    setRoleFormData({
      ...roleFormData,
      jobDetails: {
        ...roleFormData?.jobDetails,
        companyName: companyData?.companyName,
        companyId: companyData?.id,
        companyWebsite: companyData?.website ? companyData?.website : '',
        companyDescription: companyData?.description
          ? companyData?.description
          : '',
        sector: companyData?.sector ? companyData?.sector : '',
        sectorId: companyData?.sectorId ? companyData?.sectorId : '',
      },
    })
    roleForm.setFieldsValue({
      jobDetails: {
        companyName: companyData?.companyName,
        companyId: companyData?.id,
        companyWebsite: companyData?.website ? companyData?.website : '',
        companyDescription: companyData?.description
          ? companyData?.description
          : '',
        sector: companyData?.sector ? companyData?.sector : '',
        sectorId: companyData?.sectorId ? companyData?.sectorId : '',
      },
    })
  }
  const uploaderContent = () => {
    return (
      <>
        <NewCorporate
          addNewCorporate={addNewCorporate}
          setAddNewCorporate={setAddNewCorporate}
          onSetCompanyData={onSetCompanyData}
        />
      </>
    )
  }

  const uploadFooter = () => {
    return (
      <FooterFlex right>
        <Button.Primary
          htmlType="submit"
          form="corporatesForm"
          text="Save"
          // disable={Object?.keys(bulkUploadResult)?.length === 0}
          // onClick={() => handleUpdate()}
          // onClick={() => {
          //   //    setFile()
          //   // setActionDrawer(false)
          // }}
        />
      </FooterFlex>
    )
  }

  return !loading ? (
    <>
      <FormItem
        name={['jobDetails', 'companyName']}
        rules={[
          {
            required: true, // Check the flag
            message: 'Please select the company Name',
          },
        ]}
      >
        <Select
          width="100%"
          placeholder="Select Company Name"
          showSearch={true}
          allowClear={true}
          OptionData={companyListOption}
          filterOption={false}
          label="Company Name *"
          nameParam="companyName"
          valueParam="id"
          onChange={value => onChangeHandler(value, 'companyName')}
          onSearch={value => fetchCompanyData(value)}
          listHeight={170}
          textTransformInitial={true}
          disabled={isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate,
            false
          )}
        />
      </FormItem>
      {roleFormData?.status != 1 && (
        <FooterFlex right>
          <AddNewCorporate
            onClick={() => {
              if (
                !isReturnBoolean(
                  roleFormData?.roleStatus,
                  undefined,
                  roleFormData?.republishedDate
                )
              ) {
                setAddNewCorporate(true)
              }
            }}
          >
            {' '}
            Not listed? <span>Add new company</span>
          </AddNewCorporate>
        </FooterFlex>
      )}
      {/* {roleFormData?.jobDetails?.companyName === 'OTHERS' ? (
        <>
          <FormItem
            name={['jobDetails', 'otherCompanyName']}
            rules={[
              {
                required:
                  roleFormData?.jobDetails?.companyName === 'OTHERS'
                    ? true
                    : false,
                message: 'Please enter the company name',
              },
              {
                validator: (_, value) => {
                  if (value && value.trim() === '') {
                    return Promise.reject(
                      new Error('Please enter the company name')
                    )
                  }
                  return Promise.resolve()
                },
              },
            ]}
          >
            <Input
              width="100%"
              type="text"
              placeholder="Enter Company Name"
              onChange={({ target }) => {
                onChangeHandler(target.value, 'otherCompanyName')
              }}
              value={roleForm.getFieldValue(['jobDetails', 'otherCompanyName'])}
              label="Please enter the Company Name *"
            />
          </FormItem>
        </>
      ) : null} */}
      <LabelDiv> Company Website </LabelDiv>
      <FormItem name={['jobDetails', 'companyWebsite']}>
        <Input
          name={['jobDetails', 'companyWebsite']}
          width="100%"
          type="text"
          onChange={({ target }) => {
            onChangeHandler(target.value, 'companyWebsite')
          }}
          defaultValue={roleFormData?.jobDetails?.companyWebsite}
          value={roleFormData?.jobDetails?.companyWebsite}
          placeholder={'Enter company website'}
          disabled={isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate
          )}
        />
      </FormItem>
      <FormItem
        name={['jobDetails', 'sector']}
        rules={[
          {
            required: false, // Check the flag
            message: 'Please select any one Sector',
          },
        ]}
      >
        <Select
          width="100%"
          showSearch={true}
          allowClear={true}
          OptionData={sectorMaster}
          filterOption={false}
          valueParam="name"
          label="Company Sector"
          placeholder="Select Company Sector"
          onSearch={value => fetchSectormaster(value)}
          onChange={handleSectorSelect}
          onClear={() => {
            fetchSectormaster()
          }}
          listHeight={170}
          disabled={isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate
          )}
        />
      </FormItem>
      {/* <LabelDiv> Other Links </LabelDiv>
      <MultipleLink
        name="otherLinks"
        initialValues={{
          jobDetails: {
            otherLinks: [
              {
                link: '',
              },
            ],
          },
        }}
      >
        <Form.List name={['jobDetails', 'otherLinks']}>
          {(fields, { add, remove }, { errors }) =>
            fields.map((field, index) => {
              return (
                <FormItem
                  required={false}
                  key={field.key}
                  name={[key]}
                  {...field}
                  validateTrigger={['onChange', 'onBlur']}
                  rules={[
                    {
                      validator: async (_, value) => {
                        const trimmedValue =
                          typeof value === 'string' ? value.trim() : ''
                        const newOtherLinks = [
                          ...roleFormData.jobDetails.otherLinks,
                        ]
                        const findLinkArr = newOtherLinks
                          ?.filter((item, i) => i !== index)
                          ?.map(item => item.link)

                        if (findLinkArr?.includes(trimmedValue)) {
                          return Promise.reject(new Error('URL already exists'))
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1em',
                    }}
                  >
                    <Input
                      width="100%"
                      placeholder="Enter other link"
                      suffix={
                        fields.length > 1 ? (
                          <DeleteIcon
                            className="dynamic-delete-button"
                            onClick={() => handleRemove(remove, field.name)}
                          />
                        ) : null
                      }
                      onChange={({ target }) =>
                        onChangeLinks(target.value, field.key)
                      }
                      value={roleFormData?.jobDetails?.otherLinks[index]?.link}
                    />

                    {fields.length === index + 1 && (
                      <EmptyDivElement
                        onClick={() => add()}
                        style={{
                          cursor: roleFormData?.jobDetails?.otherLinks[
                            index
                          ]?.link?.trim()
                            ? 'pointer'
                            : 'not-allowed',
                          pointerEvents: roleFormData?.jobDetails?.otherLinks[
                            index
                          ]?.link?.trim()
                            ? 'auto'
                            : 'none',
                          opacity: roleFormData?.jobDetails?.otherLinks[
                            index
                          ]?.link?.trim()
                            ? 1
                            : 0.5,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <PlusIcon />
                      </EmptyDivElement>
                    )}
                  </div>
                </FormItem>
              )
            })
          }
        </Form.List>
      </MultipleLink> */}

      <FormItem
        name={['jobDetails', 'companyDescription']}
        rules={[
          {
            required: false,
            message: 'Please enter description',
          },
        ]}
        initialValue={
          roleFormData?.jobDetails?.companyDescription
            ? roleFormData?.jobDetails?.companyDescription
            : ''
        }
      >
        <RichEditor
          labelName="About Company"
          placeholder="Enter about company"
          onChange={e => onChangeHandler(e, 'companyDescription')}
          editText={key}
          setLengthError={setLengthError}
          isCompanyDescription={true}
          value={
            roleFormData?.jobDetails?.companyDescription
              ? roleFormData?.jobDetails?.companyDescription
              : ''
          }
          disabled={isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate
          )}
        />
      </FormItem>
      <FormItem
        name={['jobDetails', 'jobTitle']}
        rules={[
          {
            required: true, // Check the flag
            message: 'Please select any one job title/role',
          },
        ]}
      >
        <Select
          width="100%"
          showSearch={true}
          allowClear={true}
          OptionData={jobOptions}
          filterOption={false}
          valueParam="name"
          label="Job Title/Role *"
          placeholder="Select Job Title/Role"
          onChange={value => onChangeHandler(value, 'jobTitle')}
          onSearch={value => {
            fetchRoleData(value?.trim()?.toLowerCase())
            if (!value) {
              roleApi()
              setJobOptions([])
              setDesignationSearch('')
            }
          }}
          onClear={() => {
            setDesignationSearch('')
            roleApi()
          }}
          listHeight={170}
          disabled={isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate,
            false
          )}
        />
      </FormItem>
      <FormItem
        name={['jobDetails', 'jobFunction']}
        rules={[
          {
            required: false,
            message: 'Please select any one function',
          },
        ]}
      >
        <Select
          width="100%"
          showSearch={true}
          allowClear={true}
          OptionData={options}
          label="Function "
          placeholder="Select Function"
          valueParam="id"
          nameParam="name"
          onChange={(value, option) => {
            onChangeHandler(value, 'jobFunction')
          }}
          onSearch={data => delayFunctionToFetch(data)}
          filterOption={false}
          listHeight={170}
          disabled={isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate,
            false
          )}
        />
      </FormItem>
      {showOtherInputFunction && (
        <FormItem
          name={['jobDetails', 'otherJobFunction']}
          rules={[
            {
              required: true, // Check the flag
              message: 'Please enter the function name.',
            },
          ]}
        >
          <Input
            width="100%"
            placeholder="Enter the function"
            label="Please enter the function *"
            onChange={({ target }) => {
              onChangeHandler(target.value, 'otherJobFunction')
            }}
            disabled={isReturnBoolean(
              roleFormData?.roleStatus,
              undefined,
              roleFormData?.republishedDate,
              false
            )}
          />
        </FormItem>
      )}
      <LabelDiv>Job Type *</LabelDiv>
      <FormItem
        name={['jobDetails', 'jobCategory']}
        rules={[
          {
            required: true,
            message: 'Please select any one job type',
          },
        ]}
      >
        <RadioGroup
          onChange={({ target }) =>
            onChangeHandler(target.value, 'jobCategory')
          }
        >
          {RadioOptions1?.map((item, index) => (
            <RadioButton
              width={'30%'}
              key={index + item?.value}
              border={true}
              label={item?.label}
              value={item?.value}
              disabled={isReturnBoolean(
                roleFormData?.roleStatus,
                undefined,
                roleFormData?.republishedDate,
                false
              )}
            />
          ))}
        </RadioGroup>
      </FormItem>
      {roleFormData?.jobDetails?.jobCategory === 'INTERNSHIP' ? (
        <FormItem
          name={['jobDetails', 'internshipDuration']}
          rules={[
            {
              required: true,
              message: 'Please select the duration',
            },
          ]}
        >
          <Select
            width="100%"
            placeholder="Select Duration"
            showSearch={true}
            allowClear={true}
            filterOption={false}
            label="Duration *"
            nameParam="label"
            valueParam="value"
            onChange={value => onChangeHandler(value, 'internshipDuration')}
            onSearch={value => setSearchValue(value)}
            value={roleFormData?.jobDetails?.internshipDuration}
            OptionData={internShipDurationOption.filter(option =>
              option.label.toLowerCase().includes(searchValue.toLowerCase())
            )}
            listHeight={170}
            disabled={isReturnBoolean(
              roleFormData?.roleStatus,
              undefined,
              roleFormData?.republishedDate
            )}
          />
        </FormItem>
      ) : null}
      {roleFormData?.jobDetails?.jobCategory === 'GIGS' ? (
        <>
          <LabelDiv>Duration *</LabelDiv>
          <NumberInputDiv>
            <NumberDiv>
              <Input
                name={['jobDetails', 'durationFirstYear']}
                rules={[
                  {
                    required: true,
                    message: '',
                  },
                ]}
                defaultValue={roleFormData?.jobDetails?.durationFirstYear}
                width="60px"
                type="number"
                onChange={({ target }) => {
                  onChangeHandler(target.value, 'durationFirstYear')
                }}
                min={0}
                disabled={isReturnBoolean(
                  roleFormData?.roleStatus,
                  undefined,
                  roleFormData?.republishedDate
                )}
              />{' '}
              <NumberDivision> Yrs</NumberDivision>
              <Input
                name={['jobDetails', 'durationFirstMonth']}
                rules={[
                  {
                    required: true,
                    message: '',
                  },
                ]}
                defaultValue={roleFormData?.jobDetails?.durationFirstMonth}
                width="60px"
                type="number"
                min={0}
                max={11}
                onChange={({ target }) => {
                  onChangeHandler(target.value, 'durationFirstMonth')
                }}
                disabled={isReturnBoolean(
                  roleFormData?.roleStatus,
                  undefined,
                  roleFormData?.republishedDate
                )}
              />{' '}
              <NumberDivision>Mos</NumberDivision>
            </NumberDiv>
            <NumberDivision>-</NumberDivision>
            <NumberDiv>
              <Input
                name={['jobDetails', 'durationSecondYear']}
                rules={[
                  {
                    required: true,
                    message: '',
                  },
                ]}
                width="60px"
                type="number"
                onChange={({ target }) => {
                  onChangeHandler(target.value, 'durationSecondYear')
                }}
                min={0}
                disabled={isReturnBoolean(
                  roleFormData?.roleStatus,
                  undefined,
                  roleFormData?.republishedDate
                )}
              />{' '}
              <NumberDivision>Yrs</NumberDivision>
              <Input
                name={['jobDetails', 'durationSecondMonth']}
                rules={[
                  {
                    required: true,
                    message: '',
                  },
                ]}
                min={0}
                max={11}
                width="60px"
                type="number"
                onChange={({ target }) => {
                  onChangeHandler(target.value, 'durationSecondMonth')
                }}
                disabled={isReturnBoolean(
                  roleFormData?.roleStatus,
                  undefined,
                  roleFormData?.republishedDate
                )}
              />{' '}
              <NumberDivision>Mos</NumberDivision>
            </NumberDiv>
          </NumberInputDiv>
        </>
      ) : null}
      <div
        className="ant-form-item-explain-error"
        style={{ marginTop: '-12px' }}
        id={'gigsError'}
      >
        {gigsErr}
      </div>
      <FormItem
        name={['jobDetails', 'employmentType']}
        // rules={[
        //   {
        //     required: true,
        //     message: 'Please select any one employment type',
        //   },
        // ]}
      >
        <Toggle
          widthRight="180px"
          left="On Roll"
          right="Off Roll/Contractual"
          onClick={value => {
            onChangeHandler(value ? 'CONTRACT' : 'ONROLL', 'employmentType')
          }}
          initialValue={
            roleFormData?.jobDetails?.employmentType === 'CONTRACT'
              ? 'right'
              : 'left'
          }
          disabled={isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate,
            false
          )}
        />
      </FormItem>
      <FormItem
        name={['jobDetails', 'jobType']}
        // rules={[
        //   {
        //     required: true,
        //     message: 'Please select any one job type',
        //   },
        // ]}
      >
        <Toggle
          widthRight="180px"
          left="Full Time"
          right="Part Time"
          onClick={value => {
            onChangeHandler(value ? 'PART_TIME' : 'FULL_TIME', 'jobType')
          }}
          initialValue={
            roleFormData?.jobDetails?.jobType === 'PART_TIME' ? 'right' : 'left'
          }
          disabled={isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate,
            false
          )}
        />
      </FormItem>
      <LabelDiv>Experience Level *</LabelDiv>
      <FormItem
        name={['jobDetails', 'jobTypeLevels']}
        rules={[
          {
            required: true,
            message: 'Please select any one experience level',
          },
        ]}
      >
        <RadioGroup
          onChange={({ target }) => {
            onChangeHandler(target.value, 'jobTypeLevels')
          }}
        >
          {RadioOptions2?.map((item, index) => (
            <RadioButton
              width={'30%'}
              key={index + item?.value}
              border={true}
              label={item?.label}
              value={item?.value}
              disabled={isReturnBoolean(
                roleFormData?.roleStatus,
                undefined,
                roleFormData?.republishedDate
              )}
            />
          ))}
        </RadioGroup>
      </FormItem>
      {roleFormData?.jobDetails?.jobTypeLevels == 'BOTH' && (
        <StyledAlerts
          margin={'-13px'}
          message={
            <AlertTexts>
              Both freshers and experience candidates can apply
            </AlertTexts>
          }
          type="info"
          showIcon
          icon={<InfoIcon />}
          margintop={'10px'}
        />
      )}
      {(roleFormData?.jobDetails?.jobTypeLevels == 'BOTH' ||
        roleFormData?.jobDetails?.jobTypeLevels == 'EXPERIENCED') && (
        <>
          <LabelDiv style={{ marginBottom: '-1em' }}>
            Experience Required (in years) *
          </LabelDiv>
          <NumberInputDiv>
            <NumberDiv>
              <Input
                name={['jobDetails', 'firstYear']}
                rules={[
                  {
                    required: roleFormData?.jobDetails?.jobTypeLevels != 'BOTH',
                    message: '',
                  },
                ]}
                defaultValue={roleFormData?.jobDetails?.firstYear}
                disabled={
                  isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  ) || roleFormData?.jobDetails?.jobTypeLevels == 'BOTH'
                }
                width="60px"
                type="number"
                onChange={({ target }) => {
                  onChangeHandler(target.value, 'firstYear')
                }}
                min={0}
              />{' '}
              <NumberDivision> Yrs</NumberDivision>
              <Input
                name={['jobDetails', 'firstMonth']}
                rules={[
                  {
                    required:
                      !roleFormData?.jobDetails?.jobTypeLevels == 'BOTH',
                    message: '',
                  },
                ]}
                defaultValue={roleFormData?.jobDetails?.firstMonth}
                disabled={
                  isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  ) || roleFormData?.jobDetails?.jobTypeLevels == 'BOTH'
                }
                width="60px"
                type="number"
                min={0}
                max={11}
                onChange={({ target }) => {
                  onChangeHandler(target.value, 'firstMonth')
                }}
              />{' '}
              <NumberDivision>Mos</NumberDivision>
            </NumberDiv>
            <NumberDivision>-</NumberDivision>
            <NumberDiv>
              <Input
                name={['jobDetails', 'secondYear']}
                width="60px"
                rules={[
                  {
                    required: true,
                    message: '',
                  },
                ]}
                type="number"
                onChange={({ target }) => {
                  onChangeHandler(target.value, 'secondYear')
                }}
                min={0}
                disabled={isReturnBoolean(
                  roleFormData?.roleStatus,
                  undefined,
                  roleFormData?.republishedDate
                )}
              />{' '}
              <NumberDivision>Yrs</NumberDivision>
              <Input
                name={['jobDetails', 'secondMonth']}
                rules={[
                  {
                    required: true,
                    message: '',
                  },
                ]}
                min={0}
                max={11}
                width="60px"
                type="number"
                onChange={({ target }) => {
                  onChangeHandler(target.value, 'secondMonth')
                }}
                disabled={isReturnBoolean(
                  roleFormData?.roleStatus,
                  undefined,
                  roleFormData?.republishedDate
                )}
              />{' '}
              <NumberDivision>Mos</NumberDivision>
            </NumberDiv>
          </NumberInputDiv>
        </>
      )}
      <div
        className="ant-form-item-explain-error"
        style={{ marginTop: '-12px' }}
        id={'jobLevel_status_Id'}
      >
        {experienceErr}
      </div>
      <LabelDiv>Work style *</LabelDiv>
      <FormItem
        name={['jobDetails', 'workStyle']}
        rules={[
          {
            required: true,
            message: 'Please select any work style',
          },
        ]}
        value={roleFormData?.jobDetails?.workStyle}
      >
        <RadioGroup
          onChange={({ target }) => {
            onChangeHandler(target.value, 'workStyle')
          }}
        >
          {RadioOptions3?.map((item, index) => (
            <RadioButton
              width={'30%'}
              key={index + item?.value}
              border={true}
              label={item?.label}
              value={item?.value}
              disabled={isReturnBoolean(
                roleFormData?.roleStatus,
                undefined,
                roleFormData?.republishedDate
              )}
            />
          ))}
        </RadioGroup>
      </FormItem>
      <FormItem
        name={['jobDetails', 'description']}
        rules={[
          {
            validator: (_, value) => {
              if (!value || (value.trim() === '<p><br></p>' && !draft)) {
                return Promise.reject(new Error('Please enter description'))
              }
              return Promise.resolve()
            },
          },
        ]}
        initialValue={roleFormData?.jobDetails?.description || ''}
      >
        <RichEditor
          labelName="Job Description *"
          placeholder="Enter Job Description here.."
          onChange={e => onChangeHandler(e, 'description')}
          editText={key}
          value={roleFormData?.jobDetails?.description || ''}
          disabled={isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate
          )}
        />
      </FormItem>
      <LabelDiv> External Link </LabelDiv>
      <FormItem name={['jobDetails', 'externalLink']}>
        <Input
          width="100%"
          type="text"
          placeholder="Enter Link"
          onChange={({ target }) => {
            onChangeHandler(target.value, 'externalLink')
          }}
          disabled={isReturnBoolean(
            roleFormData?.roleStatus,
            undefined,
            roleFormData?.republishedDate,
            false
          )}
        />
      </FormItem>

      <DatePicker
        name={['jobDetails', 'startDate']}
        rules={[
          {
            required: true,
            message: 'Please enter application start date',
          },
        ]}
        width="100%"
        label="Application Start Date *"
        placeholder={dateFormat}
        dateFormat={dateFormat}
        id="startDate"
        onChange={(date, dateString) =>
          onChangeHandler(dateString, 'startDate')
        }
        disabledDate={d => !d || d.isBefore(moment().add(-1, 'day'))}
        isEditable={isReturnBoolean(roleFormData?.roleStatus, 'UPCOMING')}
      />
      <Row spacing={3} justify="space-between">
        <Col span={11}>
          <DatePicker
            name={['jobDetails', 'endDate']}
            rules={[
              {
                required: true,
                message: 'Please enter application end date',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const startDateValue = getFieldValue([
                    'jobDetails',
                    'startDate',
                  ])
                  const endDateValue =
                    getFieldValue(['jobDetails', 'endDate']) ??
                    moment(roleFormData?.jobDetails?.endDate, 'DD/MM/YYYY')
                  const currentDate = moment().startOf('day')
                  if (endDateValue) {
                    if (endDateValue.isBefore(currentDate)) {
                      return Promise.reject(
                        new Error(
                          'Application end date should not be a past date'
                        )
                      )
                    }
                  }

                  if (
                    !value ||
                    !startDateValue ||
                    moment(value).isSameOrAfter(moment(startDateValue))
                  ) {
                    return Promise.resolve()
                  }
                  return Promise
                    .resolve
                    // new Error(
                    //   'Application end date should not be greater than start date'
                    // )
                    ()
                },
              }),
            ]}
            width="100%"
            label="Application End Date *"
            placeholder={dateFormat}
            dateFormat={dateFormat}
            id="endDate"
            onChange={(date, dateString) =>
              onChangeHandler(dateString, 'endDate')
            }
            // getPopupContainer={'date_start_Id'}
            setStartPosition={'80px'}
            showToday={false}
            disabledDate={d =>
              isEditRoleOnView
                ? !d ||
                  d.isBefore(
                    moment(
                      dateConversion({
                        date: roleFormData?.jobDetails?.endDate?.split('T')[0],
                        convertTo: 'DD/MM/YYYY',
                      }),
                      dateFormat
                    ).add(1, 'day')
                  ) ||
                  d.isBefore(moment(), 'day')
                : !d ||
                  d.isBefore(
                    moment(roleFormData?.jobDetails?.startDate, dateFormat).add(
                      0,
                      'day'
                    )
                  ) ||
                  d.isBefore(moment(), 'day')
            }
          />
          <div id={'applicationEndError'}></div>
        </Col>

        <Col span={11}>
          <LabelDivWithPopup id={'endTimeStatePicker'}>
            Application End Time
          </LabelDivWithPopup>
          <FormItem
            name={['jobDetails', 'endTime']}
            rules={[
              {
                required: false,
                message: 'Please select end time',
              },
            ]}
          >
            <TimeStyles
              format="HH:mm"
              marginTop={'25px'}
              showSecond={false}
              suffixIcon={<Clock />}
              id="endTime"
              width="100%"
              color="#010E30"
              opacity="1"
              placeholder="--:--am"
              onChange={(e, value) => onChangeHandler(value, 'endTime')}
              getPopupContainer={() =>
                document.getElementById(`endTimeStatePicker`)
              }
            />
          </FormItem>
        </Col>
      </Row>
      <div
         style={{
          position: 'relative',
       }}
      >
        <FileUploader
          isDefault={true}
          file={file}
          setFile={setFile}
          setFileURL={setFileURL}
          fileURL={fileURL}
          format="(.xlsx , .csv, .jpeg, .png, .ppt, .doc, .pdf)"
          message={'Invalid file uploaded'}
          // disabled={isReturnBoolean(roleFormData?.roleStatus,undefined,roleFormData?.republishedDate)}
        />
        {isSecondEdit && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              cursor: "not-allowed",
              zIndex: 10,
              background: "transparent",   // IMPORTANT: invisible layer
            }}
          />
        )}
        {file?.map((item, index) => (
          <FileReader
            file={item}
            setFile={setFile}
            fileURL={fileURL?.[index]}
            setFileURL={setFileURL}
            progress="100"
            key={index + 'fileReader'}
            handleRemoveClick={() => handleFileRemove(index)}
          />
        ))}
      </div>
      <Drawer
        width="40%"
        title={'Add New Corporate'}
        placement="right"
        closable={true}
        visible={addNewCorporate}
        content={uploaderContent()}
        footer={uploadFooter()}
        onClose={() => {
          setAddNewCorporate(false)
        }}
      />
    </>
  ) : (
    <Spin />
  )
}

export default JobDetails